export class Base {
    id!: string;
    status!: string;
    createdAt!: string;
    updatedAt!: string;
}